<template>
    <div class="wrap">
        <div class="task_page" v-show="!caseInfo">
            <div class="page_title"><b>质检案件列表</b></div>
            <!--检索部分  -->
            <div class="search_box public_box">
                <el-form class="clearfix" :inline="true" :model="navForm">
                    <div class="form_col fl clearfix">
                        <el-form-item label="" class="formItem">
                            <span class="form_label">案件号：</span>
                            <el-input class="width_190" size="mini" v-model="navForm.caseNo" placeholder="请输入" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="" class="formItem">
                            <span class="form_label">美团案件号：</span>
                            <el-input class="width_190" size="mini" v-model="navForm.meituanCaseNo" placeholder="请输入" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="" class="formItem">
                            <span class="form_label">骑手姓名：</span>
                            <el-input class="width_190" size="mini" v-model="navForm.deliveryName" maxlength="5" placeholder="请输入" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="" class="formItem">
                            <span class="form_label">骑手身份证：</span>
                            <el-input class="width_190" size="mini" v-model="navForm.deliveryIdCard" maxlength="18" placeholder="请输入" clearable></el-input>
                        </el-form-item>
                    </div>
                    <div class="form_col fl clearfix">
                        <!-- <el-form-item label="流入时间：" class="dateBox">
                                <el-row style="width: 330px">
                                    <el-col :span="11">
                                        <el-date-picker placeholder="请选择日期" v-model="navForm.startInflowTime" type="date" value-format="yyyy-MM-dd" style="width: 100%" clearable> </el-date-picker>
                                    </el-col>
                                    <el-col class="line" style="text-align: center" :span="2">至</el-col>
                                    <el-col :span="11">
                                        <el-date-picker placeholder="请选择日期" v-model="navForm.endInflowTime" type="date" value-format="yyyy-MM-dd" style="width: 100%" clearable> </el-date-picker>
                                    </el-col>
                                </el-row>
                            </el-form-item> -->
                        <el-form-item label="" class="dateBox">
                            <span class="form_label">流入时间：</span>
                            <el-date-picker class="inheritWidth120 inheritPadding" size="mini" placeholder="请选择日期" v-model="navForm.startInflowTime" type="date" value-format="yyyy-MM-dd" clearable> </el-date-picker>
                            <span class="line" style="text-align: center">至</span>
                            <el-date-picker class="inheritWidth120 inheritPadding" size="mini" placeholder="请选择日期" v-model="navForm.endInflowTime" type="date" value-format="yyyy-MM-dd" clearable> </el-date-picker>
                        </el-form-item>
                        <el-form-item label="" class="dateBox">
                            <span class="form_label">结案时间：</span>
                            <el-date-picker class="inheritWidth120 inheritPadding" size="mini" placeholder="请选择日期" v-model="navForm.startCaseCloseTime" type="date" value-format="yyyy-MM-dd" style="width: 100%" clearable> </el-date-picker>
                            <span class="line" style="text-align: center">至</span>
                            <el-date-picker class="inheritWidth120 inheritPadding" size="mini" placeholder="请选择日期" v-model="navForm.endCaseCloseTime" type="date" value-format="yyyy-MM-dd" style="width: 100%" clearable> </el-date-picker>
                        </el-form-item>
                        <el-form-item label="" class="dateBox">
                            <span class="form_label">质检时间：</span>
                            <el-date-picker class="inheritWidth120 inheritPadding" size="mini" placeholder="请选择日期" v-model="navForm.startQualityTime" type="date" value-format="yyyy-MM-dd" style="width: 100%" clearable> </el-date-picker>
                            <span class="line" style="text-align: center">至</span>
                            <el-date-picker class="inheritWidth120 inheritPadding" size="mini" placeholder="请选择日期" v-model="navForm.endQualityTime" type="date" value-format="yyyy-MM-dd" style="width: 100%" clearable> </el-date-picker>
                        </el-form-item>
                        <el-form-item label="" class="dateBox">
                            <span class="form_label">报案时间：</span>
                            <el-date-picker class="inheritWidth120 inheritPadding" size="mini" placeholder="请选择日期" v-model="navForm.reportStartTime" type="date" value-format="yyyy-MM-dd" style="width: 100%" clearable> </el-date-picker>
                            <span class="line" style="text-align: center">至</span>
                            <el-date-picker class="inheritWidth120 inheritPadding" size="mini" placeholder="请选择日期" v-model="navForm.reportEndTime" type="date" value-format="yyyy-MM-dd" style="width: 100%" clearable> </el-date-picker>
                        </el-form-item>
                        <div class="dateBox" style="margin-bottom: 20px">
                            <el-form-item label="">
                                <div class="dateBox">
                                    <span class="form_label">结案金额：</span>
                                    <div class="amountInput">
                                        <span class="form_label">大于</span>
                                        <el-input class="width_100" size="mini" v-model.number="navForm.geAmount" maxlength="20" placeholder="请输入" clearable></el-input>
                                    </div>
                                    <div class="amountInput">
                                        <span class="form_label">小于</span>
                                        <el-input class="width_100" size="mini" v-model.number="navForm.leAmount" maxlength="20" placeholder="请输入" clearable></el-input>
                                    </div>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="dateBox">
                            <el-form-item label="">
                                <span class="form_label">理算金额：</span>
                                <div class="amountInput">
                                    <span class="form_label">大于</span>
                                    <el-input class="width_100" size="mini" v-model.number="navForm.gePredictAmount" maxlength="20" placeholder="请输入" clearable></el-input>
                                </div>
                                <div class="amountInput">
                                    <span class="form_label">小于</span>
                                    <el-input class="width_100" size="mini" v-model.number="navForm.lePredictAmount" maxlength="20" placeholder="请输入" clearable></el-input>
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form_col fl clearfix">
                        <el-form-item label="" class="formItem">
                            <span class="form_label">案件状态：</span>
                            <el-select class="width_160" v-model="navForm.currentStatusDescs" placeholder="请选择" multiple clearable @change="qualityChange">
                                <el-option v-for="(item, index) in statusOptions" :key="index" :label="item.status" :value="item.status"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="" class="formItem">
                            <span class="form_label">质检状态：</span>
                            <el-select class="width_160" v-model="navForm.qualityStatus" placeholder="请选择" clearable @change="qualityChange">
                                <el-option v-for="item in qualityInspectionOption" :key="item.metaData" :label="item.dictName" :value="item.metaData"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="" class="formItem">
                            <span class="form_label">案件标记：</span>
                            <el-select class="width_160" v-model="navForm.flagList" placeholder="请选择" multiple clearable @change="qualityChange">
                                <el-option v-for="(item, index) in flagOptions" :key="index" :label="item.label" :value="item.value"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="" class="formItem">
                            <span class="form_label">车损风险标签：</span>
                            <el-select class="width_160" v-model="navForm.category3" placeholder="请选择" multiple clearable>
                                <template v-for="item in tmpvehicleDamageLevel2">
                                    <!-- :disabled="!item.metaData" -->
                                    <el-option :key="item.id" :label="item.dictName" :value="item.dictName"></el-option>
                                </template>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="" class="formItem">
                            <span class="form_label">人伤风险标签：</span>
                            <el-select class="width_160" v-model="navForm.injuryRiskLabel2" placeholder="请选择" multiple clearable>
                                <template v-for="item in tmppersonalInjury2">
                                    <el-option :key="item.id" :label="item.dictName" :value="item.dictName"></el-option>
                                </template>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="" class="formItem">
                            <span class="form_label">模型理算状态：</span>
                            <el-select class="width_160" v-model="navForm.adjustReportFlag" placeholder="请选择" clearable @change="qualityChange">
                                <el-option label="完成" :value="true"> </el-option>
                                <el-option label="未完成" :value="false"> </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="form_col fl clearfix">
                        <el-form-item label="" class="formItem">
                            <span class="form_label">省份：</span>
                            <el-input class="width_150" v-model="navForm.accidentProvince" maxlength="20" placeholder="请输入" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="" class="formItem">
                            <span class="form_label">城市：</span>
                            <el-input class="width_150" v-model="navForm.accidentCity" maxlength="20" placeholder="请输入" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="" class="formItem">
                            <span class="form_label">任务标签：</span>
                            <el-select class="width_150" v-model="navForm.tagCode" placeholder="请选择" clearable>
                                <template v-for="item in caseQualityTagOption">
                                    <el-option :key="item.id" :label="item.dictName" :value="item.metaData"></el-option>
                                </template>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="" class="formItem">
                            <span class="form_label">优先级：</span>
                            <el-select class="width_150" v-model="navForm.orderCode" placeholder="请选择" clearable>
                                <template v-for="item in caseQualityOrderOption">
                                    <el-option :key="item.id" :label="item.dictName" :value="item.metaData"></el-option>
                                </template>
                            </el-select>
                        </el-form-item>
                    </div>
                    <el-form-item label="金额类型：" v-if="0">
                        <el-select class="width_100" v-model="navForm.amountType" placeholder="请选择" clearable>
                            <el-option label="理算金额" :value="1"> </el-option>
                            <el-option label="结案金额" :value="2"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="事故类型：" v-if="0">
                        <el-select class="width_140" :disabled="!navForm.qualityStatus" v-model="navForm.accidentType" placeholder="请选择">
                            <el-option v-for="item in tmpAccidentTypeOption" :key="item.metaData" :label="item.dictName" :value="item.metaData"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="标记时间：" class="dateBox" v-if="0">
                        <el-row style="width: 330px">
                            <el-col :span="11">
                                <el-date-picker placeholder="请选择日期" v-model="navForm.startTagTime" type="date" value-format="yyyy-MM-dd" style="width: 100%" clearable> </el-date-picker>
                            </el-col>
                            <el-col class="line" style="text-align: center" :span="2">至</el-col>
                            <el-col :span="11">
                                <el-date-picker placeholder="请选择日期" v-model="navForm.endTagTime" type="date" value-format="yyyy-MM-dd" style="width: 100%" clearable> </el-date-picker>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-form>
                <div class="btnGroups autoC">
                    <el-button type="primary" @click="searchCaseQuality(true)" style="margin-left: 0.2rem">查询</el-button>
                    <el-button type="primary" @click="enterDialog" style="margin-left: 0.2rem">录入</el-button>
                    <el-button type="primary" @click="download" style="margin-left: 0.2rem">下载</el-button>
                    <el-button type="warning" plain @click="setSearchParams(1)">质检左移</el-button>
                    <el-button type="warning" plain @click="setSearchParams(2)">案件日清</el-button>
                    <el-button :type="statisticsData.pendingReviewCount > 0 ? 'danger' : 'success'" plain>未质检：{{ statisticsData?.pendingReviewCount ?? '--' }}</el-button>
                    <el-button type="danger" plain>超时：{{ statisticsData?.timeoutCount ?? '--' }}</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <div class="main">
                <div class="table_box public_box">
                    <el-table ref="filterTable" :data="tableData" v-loading="tableLoading" style="width: 100%" height="370">
                        <el-table-column label="案件号" fixed="left" width="210">
                            <template slot-scope="scope">
                                <div class="tooltipText" @click="hrefDetail(scope.row.meituanCaseNo, scope.row.caseNo, 1)">
                                    <overflow-txt :txt="scope.row.caseNo"></overflow-txt>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="meituanCaseNo" label="美团案件号" fixed="left" width="210">
                            <template slot-scope="scope">
                                <!-- <div v-if="scope.row.adjustReportCaseNo" class="tooltipText" @click="hrefDetail(scope.row.meituanCaseNo, scope.row.caseNo, 1)">
                                    <overflow-txt :txt="scope.row.meituanCaseNo"></overflow-txt>
                                </div> -->
                                <overflow-txt :txt="scope.row.meituanCaseNo"></overflow-txt>
                            </template>
                        </el-table-column>
                        <el-table-column prop="totalPayAmount" label="案件金额"></el-table-column>
                        <!-- <el-table-column prop="adjustReportCaseNo" label="理算案件号" width="210">
                            <template slot-scope="scope">
                                <div class="tooltipText" @click="hrefDetail(scope.row.meituanCaseNo, scope.row.caseNo, 1)">
                                    <overflow-txt :txt="scope.row.caseNo"></overflow-txt>
                                </div>
                            </template>
                        </el-table-column> -->

                        <el-table-column prop="currentStatusDesc" label="案件状态"></el-table-column>
                        <el-table-column prop="currentStatusDesc" label="是否超时">
                            <template slot-scope="scope">
                                <el-tag type="danger" v-if="scope.row.timeoutFlag">超时</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="案件标记" width="100">
                            <template slot-scope="scope">
                                <span v-if="scope.row.lawsuitFlag">诉讼案件；</span>
                                <span v-if="scope.row.mediateFlag">调解案件；</span>
                                <span v-if="scope.row.rejectClaimFlag">拒赔案件；</span>
                                <span v-if="scope.row.compromiseFlag">通融案件；</span>
                                <span v-if="scope.row.followUpFlag">跟单案件；</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="category3" label="车损质检结果" width="100">
                            <template slot-scope="scope">
                                <span v-for="(item, index) in scope.row.category3" :key="index">{{ item }}；</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="injuryRiskLabel1" label="人伤质检结果" width="160"></el-table-column>
                        <el-table-column prop="orderDesc" label="优先级"></el-table-column>
                        <el-table-column prop="vehicleQuality" label="车损质检状态" width="100">
                            <template slot-scope="scope">
                                <span>{{ scope.row.vehicleQuality ? '已质检' : '未质检' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="injuryQuality" label="人伤质检状态" width="100">
                            <template slot-scope="scope">
                                <span>{{ scope.row.injuryQuality ? '已质检' : '未质检' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="hasInjury" label="是否包含人伤" width="160">
                            <template slot-scope="scope">
                                <span>{{ scope.row.hasInjury ? '是' : '否' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="inputPerson" label="录入人"></el-table-column>
                        <el-table-column prop="vehicleQualityUser" label="车损质检员" width="160"></el-table-column>
                        <el-table-column prop="injuryQualityUser" label="人伤质检员" width="160"></el-table-column>
                        <el-table-column label="标签" width="90">
                            <template slot-scope="scope">
                                <template v-if="scope.row.tags && scope.row.tags.length > 0">
                                    <el-tag v-for="item in scope.row.tags" :key="item.id" type="primary">{{ item.tagDesc }}</el-tag>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column prop="inflowTime" label="流入时间" width="140"></el-table-column>
                        <el-table-column prop="vehicleQualityTime" label="车损质检时间" width="140"></el-table-column>
                        <el-table-column prop="injuryQualityTime" label="人伤质检时间" width="140"></el-table-column>
                        <el-table-column label="操作" fixed="right" width="140">
                            <template slot-scope="scope">
                                <span class="a_color" @click="operateCase(scope.row, 'chesun')">车损质检</span>
                                <span class="a_color" style="margin-left: 15px" @click="operateCase(scope.row, 'renshang')">人伤质检</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--分页部分-->
                    <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page="navForm.page" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20]" :page-size="navForm.size" :total="navForm.total"> </el-pagination>
                </div>
            </div>
        </div>
        <!-- 录入弹窗 -->
        <el-dialog title="录入案件" :visible.sync="dialogVisible" width="30%" append-to-body center :before-close="beforeClose1">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
                <el-form-item label="任务标签：" prop="tagCode">
                    <el-select v-model="ruleForm.tagCode" placeholder="请选择任务标签" style="width: 90%">
                        <template v-for="item in caseQualityTagOption">
                            <el-option :key="item.id" :label="item.dictName" :value="item.metaData"></el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item label="优先级：" prop="orderCode">
                    <el-select v-model="ruleForm.orderCode" placeholder="请选择优先级" style="width: 90%">
                        <template v-for="item in caseQualityOrderOption">
                            <el-option :key="item.id" :label="item.dictName" :value="item.metaData"></el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item label="案件号：" prop="desc">
                    <el-input style="width: 90%" type="textarea" v-model="ruleForm.desc"></el-input>
                    <p style="color: red">注：每行一个案件号</p>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="beforeClose1">取 消</el-button>
                <el-button type="primary" @click="submitRuleForm">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 质检弹窗 -->
        <el-dialog class="zhi-dialog" :title="switchStr == 'renshang' ? '人伤质检' : '车损质检'" :visible.sync="zhiDialogVisible" width="800px" append-to-body center @close="beforeClose">
            <el-form class="dialog-box autoC clearfix" :model="zhiRuleForm" :rules="zhiRules" ref="zhiRuleForm" label-width="120px">
                <div :class="zhiRuleForm.injuryRiskCase || zhiRuleForm.vehicleRiskCase ? 'dialog-left fl' : 'dialog-left autoC'">
                    <el-form-item label="案件号：">
                        <span>{{ zhiRuleForm.caseNo }}</span>
                    </el-form-item>
                    <el-form-item label="案件标记：">
                        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                            <el-checkbox-button v-for="item in cities" :label="item.label" :key="item.value">{{ item.label }}</el-checkbox-button>
                        </el-checkbox-group>
                    </el-form-item>
                    <template v-if="switchStr == 'renshang'">
                        <el-form-item label="是否风险案件：" prop="injuryRiskCase">
                            <el-radio-group v-model="zhiRuleForm.injuryRiskCase">
                                <el-radio :label="false">否</el-radio>
                                <el-radio :label="true">是</el-radio>
                            </el-radio-group>
                            <!-- <el-checkbox class="checkboxStyle" v-model="zhiRuleForm.injuryNonComplianceFlag">不合规</el-checkbox> -->
                        </el-form-item>
                    </template>
                    <template v-else>
                        <el-form-item label="是否风险案件：" prop="vehicleRiskCase">
                            <el-radio-group v-model="zhiRuleForm.vehicleRiskCase">
                                <el-radio :label="false">否</el-radio>
                                <el-radio :label="true">是</el-radio>
                            </el-radio-group>
                            <!-- <el-checkbox class="checkboxStyle" v-model="zhiRuleForm.vehicleNonComplianceFlag">不合规</el-checkbox> -->
                        </el-form-item>
                    </template>
                    <template v-if="switchStr == 'renshang' && zhiRuleForm.injuryRiskCase">
                        <el-form-item label="可减损金额：" prop="injuryReduceAmount">
                            <el-input class="resetLineHeight" v-model.number="zhiRuleForm.injuryReduceAmount" type="number" oninput="if(value.length>10)value=value.slice(0,10)"></el-input>
                        </el-form-item>
                        <el-form-item label="估损金额：" prop="injuryEstimateAmount">
                            <el-input class="resetLineHeight" v-model.number="zhiRuleForm.injuryEstimateAmount" type="number" oninput="if(value.length>10)value=value.slice(0,10)"></el-input>
                        </el-form-item>
                        <el-form-item label="备注项：" prop="remark">
                            <el-input :class="zhiRuleForm.riskCase ? 'resetLineHeight' : 'resetLineHeight'" v-model="zhiRuleForm.injuryRemark" type="textarea" :rows="4"></el-input>
                        </el-form-item>
                    </template>
                    <template v-else-if="switchStr == 'chesun' && zhiRuleForm.vehicleRiskCase">
                        <el-form-item label="可减损金额：" prop="vehicleReduceAmount">
                            <el-input class="resetLineHeight" v-model.number="zhiRuleForm.vehicleReduceAmount" type="number" oninput="if(value.length>10)value=value.slice(0,10)"></el-input>
                        </el-form-item>
                        <el-form-item label="估损金额：" prop="vehicleEstimateAmount">
                            <el-input class="resetLineHeight" v-model.number="zhiRuleForm.vehicleEstimateAmount" type="number" oninput="if(value.length>10)value=value.slice(0,10)"></el-input>
                        </el-form-item>
                    </template>
                    <el-form-item label="备注项：" prop="remark">
                        <el-input :class="zhiRuleForm.riskCase ? 'resetLineHeight' : 'resetLineHeight'" v-model="zhiRuleForm.vehicleRemark" type="textarea" :rows="4"></el-input>
                    </el-form-item>
                    <el-form-item class="tagFormItem" label="AI标签：" prop="remark">
                        <!-- <i :class="{ formIcon: 1, 'el-icon-refresh-right': !refreshLoading, 'el-icon-loading': refreshLoading }" @click="(e) => getCaseModelRisk(rowItemData, 'refresh')"></i> -->
                        <div :class="{ aiTag: 1, unfoldTag: zhiRuleForm.injuryRiskCase || zhiRuleForm.vehicleRiskCase }">
                            <el-tag v-for="tag in caseModelRiskData" :key="tag.riskId" closable :disable-transitions="true" @close="handleTagClose(tag)" v-if="!tag.innerRisk">
                                {{ tag.riskName }}
                            </el-tag>
                        </div>
                    </el-form-item>
                </div>
                <div class="dialog-right fr" v-if="switchStr == 'renshang' && zhiRuleForm.injuryRiskCase">
                    <div class="right-div">
                        <el-form-item class="newLeft" label="人伤风险点：" prop="injuryRiskLabel1" required>
                            <div class="right-div">
                                <el-select v-model="zhiRuleForm.injuryRiskLabel1" placeholder="一级风险点" multiple clearable @change="(e) => getCategory(1, e)">
                                    <template v-for="item in personalInjury1">
                                        <el-option :key="item.id" :label="item.dictName" :value="item.dictName"></el-option>
                                    </template>
                                </el-select>
                            </div>
                        </el-form-item>
                        <el-form-item class="newLeft" label="" prop="injuryRiskLabel2" required>
                            <div class="right-div">
                                <el-select v-model="zhiRuleForm.injuryRiskLabel2" placeholder="二级风险点" multiple clearable>
                                    <template v-for="item in personalInjury2">
                                        <el-option :key="item.id" :label="item.dictName" :value="item.dictName"></el-option>
                                    </template>
                                </el-select>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="dialog-right fr" v-else-if="switchStr == 'chesun' && zhiRuleForm.vehicleRiskCase">
                    <el-form-item class="none-left" label="车损风险点：" prop="vehicleRiskLabel2" required> </el-form-item>
                    <div class="right-div">
                        <el-select v-model="zhiRuleForm.vehicleRiskLabel1" placeholder="一级风险" multiple @change="(e) => getCategory(0, e)">
                            <template v-for="item in vehicleDamageLevel1">
                                <el-option :key="item.id" :label="item.dictName" :value="item.dictName"></el-option>
                            </template>
                        </el-select>
                    </div>
                    <div class="right-div">
                        <el-select v-model="zhiRuleForm.vehicleRiskLabel2" placeholder="二级风险" multiple>
                            <template v-for="item in vehicleDamageLevel2">
                                <el-option :key="item.id" :label="item.dictName" :value="item.dictName"></el-option>
                            </template>
                        </el-select>
                    </div>
                    <div class="right-div" v-if="0">
                        <el-select v-model="zhiRuleForm.category3" placeholder="具体项" multiple clearable>
                            <template v-for="item in category3Option">
                                <el-option :key="item.id" :label="item.dictName" :value="item.dictName" :disabled="!item.metaData"></el-option>
                            </template>
                        </el-select>
                    </div>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="warning" :loading="refreshLoading" @click="(e) => getCaseModelRisk(rowItemData, 'refresh')">重置AI标签</el-button>
                <el-button type="danger" @click="(e) => submitZhiForm(true, e)">重置质检</el-button>
                <el-button type="primary" @click="(e) => submitZhiForm(null, e)">确 定</el-button>
                <el-button type="success" @click="copyResult">复制质检结果</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import CaseInfo from '@/components/staging/index';
import QualityInspectionDialog from '@/components/staging/QualityInspectionDialog.vue';
export default {
    components: {
        CaseInfo,
        QualityInspectionDialog
    },
    data() {
        return {
            tableLoading: true,
            creatCaseFlag: false,
            refreshLoading: false,
            navForm: {
                caseNo: '',
                // caseNo: '2004359858400411744',
                tagCode: '',
                orderCode: '',
                qualityStatus: '',
                currentStatusDescs: ['赔付成功', '支付成功'],
                adjustReportFlag: null,
                startInflowTime: '',
                endInflowTime: '',
                startQualityTime: '',
                endQualityTime: '',
                startTagTime: '',
                endTagTime: '',
                startCaseCloseTime: '',
                endCaseCloseTime: '',
                reportStartTime: '',
                reportEndTime: '',
                meituanCaseNo: '',
                deliveryName: '',
                deliveryIdCard: '',
                accidentProvince: '',
                accidentCity: '',
                amountType: '',
                geAmount: '',
                leAmount: '',
                gePredictAmount: '',
                lePredictAmount: '',
                accidentType: '',
                orderField: '',
                orderType: '',
                category3: [],
                injuryRiskLabel2: [],
                size: 10,
                page: 1,
                total: 0
            },
            rowItemData: null,
            caseModelRiskData: [],
            ruleForm: {
                tagCode: '',
                orderCode: '',
                desc: '',
                caseNos: []
            },
            totalPage: 0,
            currentPage: 10,
            dialogVisible: false,
            loading: false,
            caseInfo: false,
            tableData: [],
            options: [],
            caseRowData: {},
            caseJobAggInfoVo: {},
            aggUserCaseJobVos: {},
            aggUserCaseJobVosOutside: {},
            statisticsFlag: false,
            dialogVisible: false,
            rules: {
                orderCode: [{ required: true, message: '请选择任务标签', trigger: 'change' }],
                tagCode: [{ required: true, message: '请选择优先级', trigger: 'change' }],
                desc: [{ required: true, message: '请填写案件号', trigger: 'blur' }]
            },
            caseQualityOrderOption: [],
            caseQualityTagOption: [],
            zhiDialogVisible: false,
            zhiRules: {
                reduceAmount: [{ required: true, message: '请输入', trigger: 'blur' }],
                estimateAmount: [{ required: true, message: '请输入', trigger: 'blur' }],
                totalPayAmount: [{ required: true, message: '请输入', trigger: 'blur' }],
                injuryReduceAmount: [{ required: true, message: '请输入', trigger: 'blur' }],
                injuryEstimateAmount: [{ required: true, message: '请输入', trigger: 'blur' }],
                vehicleReduceAmount: [{ required: true, message: '请输入', trigger: 'blur' }],
                vehicleEstimateAmount: [{ required: true, message: '请输入', trigger: 'blur' }],
                injuryRiskLabel1: [{ required: true, message: '请选择风险点', trigger: 'change' }],
                injuryRiskLabel2: [{ required: true, message: '请选择风险点', trigger: 'change' }],
                vehicleRiskLabel2: [{ required: true, message: '请选择风险点', trigger: 'change' }],

                category3: [{ required: true, message: '请选择完整风险点', trigger: 'change' }],
                desc: [{ required: true, message: '请填写案件号', trigger: 'blur' }]
            },
            category1Option: [],
            category2Option: [],
            category3Option: [],
            zhiRuleForm: {
                caseNo: '',
                riskCase: '',
                reduceAmount: '',
                estimateAmount: '',
                injuryReduceAmount: '',
                injuryEstimateAmount: '',
                injuryReduceAmount: '',
                injuryEstimateAmount: '',
                totalPayAmount: '',
                vehicleRiskCase: false,
                injuryRiskCase: false,
                vehicleRiskLabel1: '',
                vehicleRiskLabel2: '',
                injuryRiskLabel1: '',
                injuryRiskLabel2: [],
                remark: null,
                vehicleRemark: null,
                injuryRemark: null,
                injuryNonComplianceFlag: '',
                vehicleNonComplianceFlag: ''
            },
            userOptions: [],
            zhiOptions: [
                { label: '是', value: true },
                { label: '否', value: false }
            ],
            accidentTypeOption: [],
            tmpAccidentTypeOption: [],
            qualityInspectionOption: [],
            riskTypeOption: [],
            riskTypeOption2: [],
            switchStr: '',
            statusOptions: [],
            checkedCities: [],
            cities: [
                {
                    label: '诉讼',
                    val: 'lawsuitFlag'
                },
                {
                    label: '调解',
                    val: 'mediateFlag'
                },
                // {
                //     label: '拒赔',
                //     val: 'rejectClaimFlag'
                // },
                {
                    label: '通融',
                    val: 'compromiseFlag'
                },
                {
                    label: '跟单',
                    val: 'followUpFlag'
                }
            ],
            citiesMapping: {
                诉讼: 'lawsuitFlag',
                调解: 'mediateFlag',
                拒赔: 'rejectClaimFlag',
                通融: 'compromiseFlag',
                跟单: 'followUpFlag'
            },
            flagOptions: [
                {
                    label: '诉讼案件',
                    value: 1
                },
                {
                    label: '调解案件',
                    value: 2
                },
                {
                    label: '拒赔案件',
                    value: 3
                },
                {
                    label: '通融案件',
                    value: 4
                },
                {
                    label: '非诉讼',
                    value: 5
                },
                {
                    label: '非调解',
                    value: 6
                },
                {
                    label: '非拒赔',
                    value: 7
                },
                {
                    label: '非通融',
                    value: 8
                },
                {
                    label: '跟单',
                    value: 9
                },
                {
                    label: '非跟单',
                    value: 10
                }
            ],
            vehicleDamageLevel1: [],
            vehicleDamageLevel2: [],
            tmpvehicleDamageLevel2: [],
            personalInjury1: [],
            personalInjury2: [],
            tmppersonalInjury2: [],
            prevValue: [],
            statisticsData: {}
        };
    },
    mounted() {
        this.getQualityStatistics();
        // 获取案件列表
        this.searchCaseQuality();
        // 优先级
        this.getCaseQualityOrder();
        // 任务标签
        this.getCaseQualityTag();
        // 车损1级风险标签
        this.searchCaseQualityRiskLabel1(0, 'QUALITY_VEHICLE_RISK_LABEL1', 'vehicleDamageLevel1', true);
        // 人伤1级风险标签
        this.searchCaseQualityRiskLabel1(1, 'QUALITY_INJURY_RISK_LABEL1', 'personalInjury1', true);

        this.getResponsibleExaminer();
        this.getCaseQualityHumanInjuryRisk();

        // 事故类型 枚举
        this.getPublicEnum('CASE_QUALITY_ACCIDENT_TYPE', 'accidentTypeOption');
        // 质检状态 枚举
        this.getPublicEnum('CASE_QUALITY_STATUS', 'qualityInspectionOption');
        // // // 人伤风险类型1 枚举
        // this.getPublicEnum('CASE_QUALITY_HUMAN_INJURY_RISK_01', 'riskTypeOption');
        // // // 人伤风险类型2 枚举
        // this.getPublicEnum('CASE_QUALITY_HUMAN_INJURY_RISK_02', 'riskTypeOption2');
        this.getCaseStatus();
    },
    methods: {
        copyResult() {
            // 人伤
            // this.zhiRuleForm.injuryQuality
            // injuryReduceAmount
            // 车损
            // this.zhiRuleForm.vehicleQuality
            // vehicleReduceAmount

            // 检查zhiRuleForm是否存在
            if (!this.zhiRuleForm) {
                this.$message.warning('质检数据不存在');
                return;
            }

            // 检查案件号是否存在
            const caseNo = this.zhiRuleForm.caseNo;
            if (!caseNo) {
                this.$message.warning('案件号不存在');
                return;
            }

            let str = `我们系统监控到一个未决风险案件  【${caseNo}】，建议尝试减损。其中`;
            let hasRisk = false;

            // 人伤风险判空处理
            if (this.zhiRuleForm.injuryReduceAmount > 0) {
                const injuryReduceAmount = this.zhiRuleForm.injuryReduceAmount || 0;
                str += `【人伤风险】${this.zhiRuleForm.injuryRemark}，预计可减损${injuryReduceAmount}元。`;
                hasRisk = true;
            }

            // 车物风险判空处理
            if (this.zhiRuleForm.vehicleReduceAmount > 0) {
                const vehicleReduceAmount = this.zhiRuleForm.vehicleReduceAmount || 0;
                str += `【车物风险】${this.zhiRuleForm.vehicleRemark}，预计可减损${vehicleReduceAmount}元。`;
                hasRisk = true;
            }

            // 只有存在风险信息时才复制
            if (hasRisk) {
                // 根据人伤和车损情况动态设置描述文本
                let tooltipStr = '减损内容';
                if (this.zhiRuleForm.injuryReduceAmount > 0 && !(this.zhiRuleForm.vehicleReduceAmount > 0)) {
                    tooltipStr = '人伤减损';
                } else if (!(this.zhiRuleForm.injuryReduceAmount > 0) && this.zhiRuleForm.vehicleReduceAmount > 0) {
                    tooltipStr = '车损减损';
                }
                console.log(str);

                this.copyText(str, tooltipStr);
            } else {
                this.$message.info('暂无风险信息可复制');
            }
        },
        copyText(text, tooltipStr) {
            let textarea = document.createElement('textarea'); //创建临时元素
            textarea.value = text; //设置要复制的内容
            document.body.appendChild(textarea); //将该元素添加到页面上
            textarea.select(); //选中输入框中的内容
            try {
                let successful = document.execCommand('copy'); //执行复制命令
                if (successful) {
                    this.$message.success(`${tooltipStr}复制成功！`);
                } else {
                    console.log('无法复制！');
                }
            } catch (err) {
                console.error('无法复制！', err);
            } finally {
                document.body.removeChild(textarea); //移除临时元素
            }
        },
        setSearchParams(type) {
            if (type == 1) {
                // 质检左移：金额区间大于（理算）：5000 && 质检状态：未质检 && 流入时间：前一天
                // @ApiModelProperty(value = "排序字段 inflow_time=流入时间 quality_time=质检时间 judgementAuditResTime=初审时间 reviewAuditResTime=复审时间")
                // private String orderField;

                // @ApiModelProperty(value = "排序方式 asc=升序 desc=降序")
                // private String orderType;

                this.navForm.geAmount = 5000;
                this.navForm.qualityStatus = '5';
                this.navForm.amountType = 1;
                this.navForm.currentStatusDescs = ['待支付', '赔付成功', '支付成功'];
                this.navForm.flagList = [5, 6];
                let { startTime, endTime, currentTime } = this.getPreviousDate(0);
                this.navForm.startInflowTime = startTime;
                this.navForm.endInflowTime = currentTime;
                this.navForm.startCaseCloseTime = null;
                this.navForm.endCaseCloseTime = null;
                this.navForm.orderField = 'inflow_time';
                this.navForm.orderType = 'asc';
            } else {
                // 结案日清：金额区间大于：5000 && 质检状态：未质检 && 结案时间：前一天
                this.navForm.geAmount = 5000;
                this.navForm.qualityStatus = '5';
                this.navForm.amountType = 2;
                this.navForm.currentStatusDescs = ['赔付成功', '支付成功'];
                this.navForm.flagList = [5, 6];
                let { startTime, endTime, currentTime } = this.getPreviousDate(1);
                this.navForm.startCaseCloseTime = startTime;
                this.navForm.endCaseCloseTime = currentTime;
                this.navForm.startInflowTime = null;
                this.navForm.endInflowTime = null;
            }

            this.searchCaseQuality();
        },
        getQualityStatistics() {
            this.instance.get('/caseQuality/getQualityStatistics', { params: {} }).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    this.statisticsData = data.data;
                    setTimeout(() => {
                        this.getQualityStatistics();
                    }, 60000);
                }
            });
        },
        handleDelOptions(riskType, val) {
            // 计算被删除的项：上一次有但当前没有的项
            const deletedItems = this.prevValue.filter((item) => !val.includes(item));

            // 打印被删除的项（如果有的话）
            let deletedLabels = [];
            if (deletedItems.length > 0) {
                // 如需获取对应的label，可进一步处理
                deletedLabels = deletedItems.map((val) => {
                    const item = this.options.find((opt) => opt.value === val);
                    return item ? item.label : val;
                });
            }

            let tmpDelArr = [];

            let tmpSelectLevel2 = [];

            if (riskType == 0) {
                tmpSelectLevel2 = this.tmpvehicleDamageLevel2;
            } else {
                tmpSelectLevel2 = this.tmppersonalInjury2;
            }
            tmpSelectLevel2.forEach((item) => {
                if (item.expandInfo == deletedLabels[0]) {
                    tmpDelArr.push(item);
                }
            });

            // 更新上一次的值为当前值（供下次对比）
            this.prevValue = [...val];

            // 提取a中所有dictName组成数组
            const aDictNames = tmpDelArr.map((item) => item.dictName);

            // 过滤b中不在aDictNames中的元素
            const result = this.zhiRuleForm.injuryRiskLabel2.filter((item) => !aDictNames.includes(item));

            return result;
        },
        handleCheckedCitiesChange(val) {
            for (const key in this.citiesMapping) {
                if (val.indexOf(key) > -1) {
                    this.zhiRuleForm[this.citiesMapping[key]] = true;
                } else {
                    this.zhiRuleForm[this.citiesMapping[key]] = false;
                }
            }
        },
        //获取案件状态
        getCaseStatus() {
            this.statusOptions = [];
            this.instance
                .get('/case/getCaseStatus', {
                    params: {}
                })
                .then((res) => {
                    if (res.data.code == 1) {
                        this.statusOptions = res.data.data;
                    }
                });
        },
        hrefDetail(caseNo, oldCaseNo, typeStr) {
            let url = 'https://www.jchunuo.com/fe/insurance-claim-service-platform/index.html#/detail/caseDetail/';
            if (oldCaseNo.indexOf('old') != -1) {
                url = 'https://awp.meituan.com/ffe/insurance-claim-platform/index/index.html?code=MGAr4r&state=dx_auth_interceptor#/case?caseId=';
            } else {
                url = 'https://www.jchunuo.com/fe/insurance-claim-service-platform/index.html#/detail/caseDetail/';
            }

            if (typeStr == 1) {
                if (oldCaseNo.indexOf('old') == -1) {
                    caseNo = oldCaseNo;
                    url = `${location.origin}/calculatorTool/medicalThreeColumn?t=1763031585981&caseNo=`;
                }
            }
            window.open(url + caseNo);
        },
        download() {
            let queryForm = JSON.parse(JSON.stringify(this.navForm));
            this.instance({
                method: 'post',
                url: '/caseQuality/downloadCaseQuality',
                data: queryForm,
                responseType: 'blob',
                headers: {
                    // 'Content-Type':"text/csv;charset=UTF-8",
                }
            })
                .then((res) => {
                    let url = window.URL.createObjectURL(new Blob([res.data]));
                    let link = document.createElement('a');
                    link.style.display = 'none';
                    link.href = url;
                    link.setAttribute('download', '质检案件.xls'); //指定下载后的文件名，防跳转
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        /**
         * 获取前n天的开始时间和结束时间，以及当天时间信息
         * @param {number} days - 天数，默认获取前1天
         * @returns {Object} 包含以下属性的对象：
         * startTime: 前n天的开始时间，格式为YYYY-MM-DD 00:00:00
         * endTime: 前n天的结束时间，格式为YYYY-MM-DD 23:59:59
         * todayStartTime: 当天的开始时间，格式为YYYY-MM-DD 00:00:00
         * todayEndTime: 当天的结束时间，格式为YYYY-MM-DD 23:59:59
         * currentTime: 当前时间，格式为YYYY-MM-DD HH:mm:ss
         */
        getPreviousDate(days) {
            // 获取当前日期
            const today = new Date();

            // 计算前n天的日期
            const previousDate = new Date();
            previousDate.setDate(previousDate.getDate() - days);

            // 格式化前n天的日期
            const prevYear = previousDate.getFullYear();
            const prevMonth = String(previousDate.getMonth() + 1).padStart(2, '0');
            const prevDay = String(previousDate.getDate()).padStart(2, '0');

            // 格式化当天的日期
            const todayYear = today.getFullYear();
            const todayMonth = String(today.getMonth() + 1).padStart(2, '0');
            const todayDay = String(today.getDate()).padStart(2, '0');
            const hours = String(today.getHours()).padStart(2, '0');
            const minutes = String(today.getMinutes()).padStart(2, '0');
            const seconds = String(today.getSeconds()).padStart(2, '0');

            // 构建返回的时间信息
            return {
                startTime: `${prevYear}-${prevMonth}-${prevDay}`, // 前n天开始时间
                endTime: `${prevYear}-${prevMonth}-${prevDay}`, // 前n天结束时间
                todayStartTime: `${todayYear}-${todayMonth}-${todayDay} 00:00:00`, // 当天开始时间
                todayEndTime: `${todayYear}-${todayMonth}-${todayDay} 23:59:59`, // 当天结束时间
                currentTime: `${todayYear}-${todayMonth}-${todayDay}` // 当前时间
            };
        },
        // 质检状态变化处理方法
        qualityChange(val) {
            let tmpOption = [];
            this.navForm.accidentType = '';
            this.qualityInspectionOption.forEach((item) => {
                if (item.metaData == val) {
                    this.accidentTypeOption.forEach((items) => {
                        if (items.metaData == item.expandInfo) {
                            tmpOption.push(items);
                        }
                    });
                }
            });
            this.tmpAccidentTypeOption = tmpOption;
        },
        getCaseQualityHumanInjuryRisk() {
            this.instance.get('/caseQuality/getCaseQualityHumanInjuryRisk', { params: {} }).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                }
            });
        },
        getResponsibleExaminer() {
            this.instance.post('/caseJobCheck/searchCommitJobUser', {}).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    data.data.forEach((item) => {
                        item.value = item.username;
                        item.label = item.nikeName;
                    });
                    this.userOptions = data.data;
                    this.userOptions.unshift({ value: 'all', label: '全部' });
                }
            });
        },
        beforeClose1() {
            this.dialogVisible = false;
            this.$refs.ruleForm.resetFields();
        },
        beforeClose() {
            this.zhiDialogVisible = false;
            this.$refs.zhiRuleForm.resetFields();
            this.zhiRuleForm = {
                caseNo: '',
                riskCase: '',
                reduceAmount: '',
                estimateAmount: '',
                injuryReduceAmount: '',
                injuryEstimateAmount: '',
                injuryReduceAmount: '',
                injuryEstimateAmount: '',
                totalPayAmount: '',
                vehicleRiskCase: false,
                injuryRiskCase: false,
                vehicleRiskLabel1: '',
                vehicleRiskLabel2: '',
                injuryRiskLabel1: '',
                injuryRiskLabel2: [],
                remark: null,
                vehicleRemark: null,
                injuryRemark: null,
                riskCase: false
            };
        },
        submitZhiForm(resetFlag) {
            if (resetFlag) {
                this.$confirm('慎重操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let apiStr = this.switchStr == 'renshang' ? `/caseQuality/reSetInjuryQuality/${this.zhiRuleForm.id}` : `/caseQuality/reSetVehicleQuality/${this.zhiRuleForm.id}`;
                    this.instance.post(apiStr, {}).then((res) => {
                        let data = res.data;
                        if (data.code == 1) {
                            // this.zhiRuleForm
                            // data.data
                            this.operateCase(data.data, this.switchStr);
                            this.$message.success('重置成功');
                        } else {
                            this.$message.error(data.message);
                        }
                    });
                });
            } else {
                this.$refs.zhiRuleForm.validate((validate) => {
                    if (validate) {
                        let keyStr = this.switchStr == 'renshang' ? 'injuryModelRisk' : 'vehicleModelRisk';
                        this.zhiRuleForm = { ...this.zhiRuleForm, [keyStr]: this.caseModelRiskData };
                        this.instance.post(this.switchStr == 'chesun' ? '/caseQuality/vehicleQuality' : '/caseQuality/injuryQuality', this.zhiRuleForm).then((res) => {
                            let data = res.data;
                            if (data.code == 1) {
                                this.searchCaseQuality();
                                this.$message.success('当前案件质检成功');
                                this.beforeClose();
                            } else {
                                this.$message.error(data.message);
                            }
                        });
                    }
                });
            }
        },
        getCategory(riskType, val) {
            switch (riskType) {
                case 0:
                    this.zhiRuleForm.vehicleRiskLabel2 = this.handleDelOptions(0, val);
                    this.searchCaseQualityRiskLabel2('QUALITY_VEHICLE_RISK_LABEL2', 'vehicleDamageLevel2', this.zhiRuleForm.vehicleRiskLabel1);
                    break;
                case 1:
                    this.zhiRuleForm.injuryRiskLabel2 = this.handleDelOptions(1, val);
                    this.searchCaseQualityRiskLabel2('QUALITY_INJURY_RISK_LABEL2', 'personalInjury2', this.zhiRuleForm.injuryRiskLabel1);
                    break;

                default:
                    break;
            }
        },
        searchCaseQualityRiskLabel1(searchType, dictType, optionsStr, searchLevel2Flag) {
            this.instance.post(`/caseQuality/searchCaseQualityRiskLabel1`, { dictType: dictType }).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    this[optionsStr] = data.data;
                    if (searchLevel2Flag) {
                        let tmpOptions1 = [];
                        data.data.forEach((item) => {
                            tmpOptions1.push(item.dictName);
                        });
                        this.searchCaseQualityRiskLabel2(searchType == 0 ? 'QUALITY_VEHICLE_RISK_LABEL2' : 'QUALITY_INJURY_RISK_LABEL2', searchType == 0 ? 'vehicleDamageLevel2' : 'personalInjury2', tmpOptions1, searchLevel2Flag);
                    }
                }
            });
        },
        searchCaseQualityRiskLabel2(dictType, optionsStr, options1, searchLevel2Flag) {
            this.instance.post(`/caseQuality/searchCaseQualityRiskLabel2`, { dictType: dictType, expandInfos: options1 }).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    if (searchLevel2Flag) {
                        this['tmp' + optionsStr] = data.data;
                    } else {
                        this[optionsStr] = data.data;
                    }
                }
            });
        },
        operateCase(row, name) {
            this.zhiRuleForm = this.rowItemData = row;
            this.switchStr = name;

            // 案件标记回显
            this.checkedCities = [];
            for (const key in this.citiesMapping) {
                if (row[this.citiesMapping[key]]) {
                    this.checkedCities.push(key);
                }
            }

            this.zhiDialogVisible = true;
        },
        getCaseModelRisk(rowData, flagStr) {
            if (flagStr == 'refresh') {
                this.refreshLoading = true;
            }
            let apiStr = this.switchStr == 'renshang' ? `/caseQuality/findInjuryModelRisk/${rowData.caseNo}` : `/caseQuality/findVehicleModelRisk/${rowData.caseNo}`;
            this.caseModelRiskData = [];
            this.instance.post(apiStr, {}).then((res) => {
                this.refreshLoading = false;
                let data = res.data;
                if (data.code == 1) {
                    this.caseModelRiskData = data.data;
                }
            });
        },
        handleTagClose(tag) {
            tag.innerRisk = true;
        },
        submitRuleForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.importQualityCase();
                }
            });
        },
        importQualityCase() {
            if (this.ruleForm.desc.length > 1) {
                if (this.creatCaseFlag) {
                    return;
                }
                this.creatCaseFlag = true;
                this.ruleForm.caseNos = this.ruleForm.desc.split('\n');
                this.instance.post('/caseQuality/importQualityCase', this.ruleForm).then((res) => {
                    this.creatCaseFlag = false;
                    let data = res.data;
                    if (data.code == 1) {
                        this.$message.success('案件导入成功');
                        this.searchCaseQuality();
                        this.beforeClose1();
                    } else {
                        this.$message.error(data.message);
                    }
                });
            } else {
                this.$message.error('请输入案件号');
            }
        },
        searchCaseQuality(btnFlag) {
            let queryForm = JSON.parse(JSON.stringify(this.navForm));
            queryForm.page = btnFlag ? 1 : queryForm.page;
            queryForm.size = btnFlag ? 10 : queryForm.size;
            queryForm.accidentType = queryForm.accidentType ? Number(queryForm.accidentType) : '';
            queryForm.qualityStatus = queryForm.qualityStatus ? Number(queryForm.qualityStatus) : '';

            this.tableLoading = true;
            this.instance.post('/caseQuality/searchCaseQuality', queryForm).then((res) => {
                this.tableLoading = false;
                let data = res.data;
                if (data.code == 1) {
                    this.tableData = data.data.list;
                    this.navForm.size = data.data.size;
                    this.navForm.page = data.data.current;
                    this.navForm.total = data.data.total;

                    this.$nextTick(() => {
                        this.$refs.filterTable && this.$refs.filterTable.doLayout();
                    });
                }
            });
        },
        getCaseQualityOrder() {
            this.instance.get('/caseQuality/getCaseQualityOrder', { params: {} }).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    data.data.forEach((item) => {
                        item.metaData = Number(item.metaData);
                    });
                    this.caseQualityOrderOption = data.data;
                }
            });
        },
        getCaseQualityTag() {
            this.instance.get('/caseQuality/getCaseQualityTag', { params: {} }).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    data.data.forEach((item) => {
                        item.metaData = Number(item.metaData);
                    });
                    this.caseQualityTagOption = data.data;
                }
            });
        },
        enterDialog() {
            this.dialogVisible = true;
        },
        handleSizeChange(val) {
            this.navForm.size = val;
            this.searchCaseQuality();
        },
        handleCurrentChange(val) {
            this.navForm.page = val;
            this.searchCaseQuality();
        },
        clearSelectVal(val) {}
    }
};
</script>
<style lang="less">
@import '../../assets/css/table_public.css';
.task_page {
    .search_box {
        .el-form {
            width: 1200px;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
        }
        .form_col {
            width: 285px;
        }
        .form_col {
            // border-right: 1px solid red;
            .formItem {
                float: left;
                .form_label {
                    display: inline-block;
                    width: 85px;
                    text-align: right;
                }
            }
            .dateBox {
                .el-input--prefix .el-input__inner {
                    padding-left: 5px;
                }
                .el-input__prefix {
                    display: none;
                }
                .line {
                    margin: 0 10px;
                }
            }
        }
        .form_col:nth-child(2) {
            width: 357px;
            .formItem {
                .form_label {
                    width: 100px;
                }
            }
            .amountInput {
                display: inline-block;
                .form_label {
                    margin-right: 5px;
                    margin-left: 5px;
                }
            }
        }
        .form_col:nth-child(3) {
            width: 310px;
            .formItem {
                .form_label {
                    width: 100px;
                }
            }
        }
        .form_col:nth-child(4) {
            width: 245px;
        }
        .btnGroups {
            text-align: center;
        }
    }
}
#chartDom1,
#chartDom2,
#chartDom3 {
    width: 400px;
    height: 200px;
}
.show_txt {
    padding-top: 17px;
    font-size: 14px;
    font-weight: 800;
    line-height: 23px;
    margin-left: 10%;
    position: absolute;
    left: 46%;
}
.task_cards {
    display: flex;
    justify-content: space-around;
}
.task_card {
    width: 340px;
    height: 85px;
    line-height: 85px;
    background: rgb(0, 192, 239);
    border-radius: 5px;
}
.card2 {
    background: rgb(0, 160, 87);
}
.card3 {
    background: rgb(241, 155, 18);
}
.task_card p {
    color: white;
    font-size: 20px;
    text-align: center;
}
.task_card .card_txt {
    line-height: normal;
    font-size: 12px;
    color: black;
}
.task_card .card_font {
    color: white;
    font-size: 20px;
}
.task_card .card_hot {
    color: blue;
    font-weight: 700;
    font-size: 36px;
}
.fl {
    float: left;
}
.fr {
    float: right;
}
.clearFix {
}
.clearFix:after {
    content: '';
    display: block;
    clear: both;
}
.dialog-left {
    width: 49%;
    min-width: 350px;
}
.dialog-left .el-form-item__content {
    text-align: left;
}
.dialog-right {
    .right-div {
        margin-bottom: 20px;
    }
    .none-left {
        margin-left: 0 !important;
        .el-form-item__error {
            margin-left: -120px;
        }
        label {
            text-align: left !important;
        }
    }
}
/deep/.el-form-item__content {
    margin-left: 80px !important;
}
.newLeft {
    .right-div {
        margin-bottom: 5px;
    }
}
.resetLineHeight /deep/.el-input__inner {
    line-height: 1px !important;
}
.zhi-dialog .el-dialog__footer {
    margin-top: -20px;
}

.zhi-dialog {
    .checkboxStyle {
        margin-left: 30px;
    }
    .tagFormItem {
        position: relative;
        .aiTag {
            padding: 0 5px;
            border-radius: 4px;
            .el-tag {
                margin-right: 10px;
            }
        }
        .unfoldTag {
            width: 580px;
        }
        .formIcon {
            counter-reset: red;
            position: absolute;
            left: -15px;
            top: 10px;
            cursor: pointer;
        }
        .formIcon:hover {
            color: #409eff;
        }
    }
}
</style>
